import React, { useState,useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Pagination,
  Button,
} from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import OrderCard from "./OrderCard";
import { useNavigate, useLocation } from "react-router-dom";
import { useModal } from "../../../ConfirmationModal/ModalContext";
import useToast from "../../../../API/GlobalHooks/useToast";
import { handleChangeSearch, handleEditButton_visible, handleGetOrder_list, handleNext, handleOrderStatus, handlePrev } from "./orderListModel";
import { formatDateToShortUTC, getImageUrl, handleCheckUserLogin } from "../../../../MIS/Global";
import { encrypt } from "../../../../MIS/encryption";
import { handleCancel_Order } from "../OrderProcess/orderModel";

const OrderList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const showToast = useToast();
  const { showModal } = useModal();

  const [search, setSearch] = useState("");
  const [quotations, setQuotations] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({ limit: 25, page: page,pid:handleCheckUserLogin("userData", "id")});
  const [actionLoading, setActionLoading] = useState({});

  useEffect(() => {
    let pid=handleCheckUserLogin("userData", "id");
    if(pid<=0){return navigate("/")}
     handleGetOrder_list({filter,setLoading,setTotalPage,setQuotations    
    })
  },[filter])
  

  return (
    <>
      {/* 🔹 Scoped CSS for this page */}
      <style>{`
        /* Assume your AppNavbar height is 60px, update if different */
        .order-header {
          position: fixed;
          top: 60px; 
          left: 0;
          right: 0;
          z-index: 9;
          background-color: #fff;
          padding: 0.75rem 1rem;
          border-bottom: 1px solid #dee2e6;
        }

        .order-scrollable-content {
          margin-top: 40px; /* 60(navbar) + 64(header) */
          height: calc(100vh - 40px);
          overflow-y: auto;
          padding: 1rem;
          background-color: #f8f9fa;
        }

        @media (max-width: 768px) {
          .search-pagination-col {
            flex-direction: column;
            align-items: stretch !important;
            gap: 0.75rem;
          }
          .pagination {
             justify-content: flex-end !important;
            }
          .order-scrollable-content {
            margin-top: 140px; /* taller header for mobile */
            height: calc(100vh - 140px);
          }
        }
      `}</style>

      <Container fluid className="p-0">
        {/* 🔹 Fixed Local Header (Search + Pagination) */}
        <div className="order-header">
          <Row className="align-items-center">
            <Col xs={12} md={6}>
              <h5 className="m-0">Order List</h5>
            </Col>
            <Col
              xs={12}
              md={6}
              className="d-flex justify-content-end align-items-center search-pagination-col mt-2 mt-md-0"
            >
              <InputGroup size="sm" style={{ maxWidth: 400 }} className="flex-grow-1">
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search by order no.,state,city,pin code..."
                  // value={search}                  
                  onChange={(e) => {
                    let value = e.target.value;
                    handleChangeSearch({ value,setSearch });
                  }}
                />
                <Button
                  variant="primary"
                  onClick={() => {                    
                    let newData={p_search:search.trim()}
                    setFilter((prev) => ({
                      ...prev,
                      ...newData,
                      page:1,
                    }));
                  }}
                >
                  Search
                </Button>
              </InputGroup>

              <Pagination size="sm" className="ms-md-3 mb-0 mt-2 mt-md-0">
                <Pagination.Prev
                  disabled={page === 1}
                  onClick={() => handlePrev({ setPage, page, setFilter })}
                />
                <Pagination.Item active>{`${page}/${totalPage}`}</Pagination.Item>
                <Pagination.Next
                  disabled={page === totalPage}
                  onClick={() =>
                   handleNext({ setPage, page, totalPage, setFilter })
                  }
                />
              </Pagination>
            </Col>
          </Row>
        </div>

        {/* 🔹 Scrollable Card Content */}
        <div className="order-scrollable-content">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <span
                className="text-primary spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
                style={{ width: "2rem", height: "2rem" }}
              ></span>
            </div>
          ) : quotations.length === 0 ? (
            <div className="text-center text-muted py-4">
              <h5>No records found</h5>
            </div>
          ) : (
            quotations?.map((quote, idx) => (
              <OrderCard
                key={idx}
                id={quote?.id}
                orderNumber={quote?.quote_no}
                orderDate={formatDateToShortUTC(quote?.quote_date)}
                expectedDate={quote?.due_date == "-" ? "NA": formatDateToShortUTC(quote?.due_date)}
                productImage={getImageUrl(`${quote?.product_image}`)}
                productName={quote?.product_name} 
                productCode={quote?.product_code}
                shopName={quote?.shop_name}
                address={`${quote?.party_address},${quote?.party_state},${quote?.party_city}-${quote?.party_pinCode}`}
                totalRupees={Number(quote?.grand_total).toLocaleString("en-IN", {minimumFractionDigits: 2,})}
                orderStatus={handleOrderStatus(quote?.quote_status,quote?.due_date)}
                editVisible={handleEditButton_visible(quote?.quote_status,quote?.due_date)}
                actionLoading={actionLoading}
                onView={() =>{window.open(`/view-bill/${encrypt(quote?.id)}`, '_blank', 'noopener,noreferrer');}}
                onEdit={() =>{ 
                  let dt=`${quote?.details?.[0]?.item_id}-${quote?.details?.[0]?.item_sub_id}-${quote?.id}`;
                  if(parseInt(quote?.quote_type) === 0){
                    navigate(`/order-product/${encrypt(dt)}`)
                  }else{                                        
                    navigate(`/order-process/${encrypt(dt)}`)
                  }                  
                  }}
                onCancel={()=>{
                  handleCancel_Order({showModal,id:quote?.id,
                  quotations,setQuotations,showToast,setActionLoading})
                }}  

              />
            ))
          )}
        </div>
      </Container>
    </>
  );
};

export default OrderList;
